import { Injectable } from '@angular/core';

@Injectable()
export class AppUiCustomizationService {

    /**
     * The user's collapse choice for the left aside; null until the first toggle, meaning the setting's default.
     * Kept here because the body class is rebuilt from getAppModuleBodyClass() on every navigation.
     */
    private asideMinimized: boolean = null;
    private asideHidden: boolean = null;

    getContainerClass() {
        return this.getSetting("App.UiManagement.LayoutType") === 'boxed'
            ? "m-container--responsive"
            : "m-container--fluid";
    }

    getAsideSkin() {
        return this.getSetting("App.UiManagement.Left.AsideSkin");
    }

    allowAsideHiding() {
        return this.getSetting('App.UiManagement.Left.AllowAsideHiding') === "true";
    }

    allowAsideMinimizing() {
        return this.getSetting('App.UiManagement.Left.AllowAsideMinimizing') === "true";
    }

    leftMenuUsed(): boolean {
        return this.getSetting("App.UiManagement.Left.Position") === "left";
    }

    topMenuUsed(): boolean {
        return this.getSetting("App.UiManagement.Left.Position") === "top";
    }

    /** What the desktop collapse button does: minimize to icons when allowed, else hide the aside; null shows no button. */
    getAsideCollapseMode(): "minimize" | "hide" {
        if (this.allowAsideMinimizing()) {
            return "minimize";
        }
        return this.allowAsideHiding() ? "hide" : null;
    }

    isAsideMinimized(): boolean {
        return this.asideMinimized !== null
            ? this.asideMinimized
            : this.getSetting("App.UiManagement.Left.DefaultMinimizedAside") === "true";
    }

    isAsideHidden(): boolean {
        return this.asideHidden !== null
            ? this.asideHidden
            : this.getSetting("App.UiManagement.Left.DefaultHiddenAside") === "true";
    }

    isAsideCollapsed(): boolean {
        return this.isAsideMinimized() || this.isAsideHidden();
    }

    /** Expands a collapsed aside, or collapses it the way getAsideCollapseMode() says; applied to the body at once. */
    toggleAside(): void {
        this.setAsideCollapsed(!this.isAsideCollapsed());
    }

    setAsideCollapsed(collapsed: boolean): void {
        const mode = this.getAsideCollapseMode();
        this.asideMinimized = collapsed && mode === "minimize";
        this.asideHidden = collapsed && mode === "hide";
        $("body")
            .toggleClass("m-aside-left--minimize m-brand--minimize", this.asideMinimized)
            .toggleClass("m-aside-left--hide", this.asideHidden || this.topMenuUsed());
    }

    getAppModuleBodyClass(): string {
        return "m-page--" + this.getSetting("App.UiManagement.LayoutType") + " m--skin-" + this.getSetting("App.UiManagement.ContentSkin") + " " +
            (this.getSetting("App.UiManagement.PageLoader") ? "m-page--loading" : "") + " " +
            (this.getSetting("App.UiManagement.PageLoader") !== "blank" ? ("m-content--skin-" + this.getSetting("App.UiManagement.ContentSkin")) : "") + " " +
            "m-header--" + (this.getSetting("App.UiManagement.Header.DesktopFixedHeader") === "true" ? "fixed" : "static") + " " +
            (this.getSetting("App.UiManagement.Header.MobileFixedHeader") === "true" ? "m-header--fixed-mobile" : "") + " " +
            (this.getSetting("App.UiManagement.Left.FixedAside") === "true" ? "m-aside-left--fixed" : "") + " " +
            (this.isAsideMinimized() ? "m-aside-left--minimize m-brand--minimize" : "") + " " +
            (this.isAsideHidden() || this.topMenuUsed() ? "m-aside-left--hide" : "") + " " +
            "m-aside-left--enabled" + " " +
            "m-aside-left--skin-" + this.getSetting("App.UiManagement.Left.AsideSkin") + " " +
            "m-aside-left--offcanvas" + " " +
            (this.getSetting("App.UiManagement.Footer.FixedFooter") === "true" && this.getSetting("App.UiManagement.LayoutType") !== "boxed" ? "m-footer--fixed" : "");
    }

    getAccountModuleBodyClass() {
        return 'm--skin- m-header--fixed m-header--fixed-mobile m-aside-left--enabled m-aside-left--skin-dark m-aside-left--offcanvas m-footer--push m-aside--offcanvas-default';
    }

    getSelectEditionBodyClass() {
        return 'm--skin-';
    }

    getHeaderClass() {
        return '';
    }

    //User navigation menu
    getSideBarMenuClass(): string {
        let menuCssClass = 'm-aside-menu m-aside-menu--skin-' + this.getSetting('App.UiManagement.Left.AsideSkin');
        menuCssClass += ' m-aside-menu--submenu-skin-';

        if (this.getSetting("App.UiManagement.Left.DropdownSubmenuSkin") === 'inherit') {
            menuCssClass += this.getSetting("App.UiManagement.Left.AsideSkin");
        } else {
            menuCssClass += this.getSetting("App.UiManagement.Left.DropdownSubmenuSkin");
        }

        if (this.getSetting("App.UiManagement.Left.SubmenuToggle") === 'dropdown') {
            menuCssClass += ' m-aside-menu--dropdown';
        }

        return menuCssClass;
    }

    getMenuListClass(): string {
        if (this.getSetting("App.UiManagement.Left.DropdownSubmenuArrow")) {
            return 'm-menu__nav--dropdown-submenu-arrow';
        }

        return '';
    }

    getTopBarMenuClass(): string {
        let menuCssClass = 'm-container m-container--responsive m-container--full-height m-page__container';
        if (this.getSetting("App.UiManagement.LayoutType") === "boxed") {
            return menuCssClass + ' m-container--xxl';
        }

        return menuCssClass;
    }

    getIsMenuDropdown(): boolean {
        return this.getSetting("App.UiManagement.Left.SubmenuToggle") === "dropdown";
    }

    getIsMenuScrollable(): boolean {
        return this.getSetting("App.UiManagement.Left.FixedAside") === "true";
    }

    getIsMenuMinimizable(): boolean {
        return this.getSetting('App.UiManagement.Header.DesktopMinimizeMode') !== "";
    }

    getIsMenuMinimizableMobile(): boolean {
        return this.getSetting('App.UiManagement.Header.MobileFixedHeader') === "true";
    }

    private getSetting(key: string): string {
        let setting = abp.setting.get(key);
        if (!setting) {
            return null;
        }

        return abp.setting.get(key).toLocaleLowerCase();
    }
}



// WEBPACK FOOTER //
// ./src/shared/common/ui/app-ui-customization.service.ts